<!-- <app-progress-indicator *ngIf="isLoadingLeadDetails" text="Please wait while we load"></app-progress-indicator> -->
<div class="section-in-progress" *ngIf="isLoadingLeadDetails">
  <div class="spinner-content">
    <mat-spinner [diameter]="30"></mat-spinner>
    <span>Please wait while we load</span>
  </div>
</div>
<div class="row mt-4">
  <div class="col-md-3 col-sm-12 col-12 card-ht mb-4 sm-card">
    <mat-card style="height: 174px">
      <mat-card-content>
        <mat-card-title class="Card-title"><h4>New Leads</h4></mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <h1 class="mt-2 value">{{ logActivityDetails.signUp || 0 }}</h1>
            <div>in the last month</div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-md-3 col-sm-12 col-12 card-ht mb-4 sm-card">
    <mat-card style="height: 174px">
      <mat-card-content>
        <mat-card-title class="Card-title"><h4>Qualified Leads</h4></mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <h1 class="mt-2 value">{{ logActivityDetails.qualifiedLead || 0 }}</h1>
          </div>
          <div>
            <div>Lead score ≥ 30 or Sales Qualified</div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-3 col-sm-12 col-12 card-ht mb-4 sm-card">
    <mat-card style="height: 174px">
      <mat-card-content>
        <mat-card-title class="Card-title"><h4>All Engaged Leads</h4></mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div>
            <h1 class="mt-2 value">{{ logActivityDetails.engagedLeads || 0 }}</h1>
          </div>
          <div>
            <div>Lead score ≥ 15</div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-3 col-sm-12 col-12 card-ht mb-4 sm-card">
    <mat-card
      class="mb-2"
      style="height: 80px; padding-top: 20px !important ; cursor: pointer; margin-bottom: 13px !important"
      (click)="navigateToMyClients('isActive')"
    >
      <mat-card-content>
        <mat-card-title class="Card-title">
          <div class="d-flex w-100 active-user">
            <div class="w-80 cpl-10">
              <h4 class="w-100">
                Active Users
                <img
                  matTooltip="The count displayed here represents the number of registered & guest users who have been actively engaged with the system within the past 5 minutes."
                  src="assets/images/info-circle.svg"
                  height="16"
                />
              </h4>
              <div class="registered">
                Registered: <b>{{ logActivityDetails.activeUsers || 0 }}</b> | Guest:
                <b>{{ logActivityDetails.activeGuestUsers || 0 }}</b>
              </div>
            </div>
            <div class="w-20">
              <h1 class="value float-right">
                {{
                  ((logActivityDetails.activeUsers && logActivityDetails.activeUsers) || 0) +
                    ((logActivityDetails.activeGuestUsers && logActivityDetails.activeGuestUsers) || 0)
                }}
              </h1>
            </div>
          </div>
        </mat-card-title>
        <div class="clearfix"></div>
      </mat-card-content>
    </mat-card>
    <mat-card
      style="height: 80px; padding-top: 20px !important ; cursor: pointer"
      (click)="navigateToMyClients('isRecentlyActive')"
    >
      <mat-card-content>
        <mat-card-title class="Card-title">
          <div class="d-flex w-100 recently-active">
            <div class="w-80 cpl-10">
              <h4 class="w-100">
                Recently Active
                <img
                  matTooltip="This count represents the number of registered & guest users who had been active in the last 8 hours, excluding the currently active users."
                  src="assets/images/info-circle.svg"
                  height="16"
                />
              </h4>
              <div class="registered">
                Registered: <b>{{ logActivityDetails.recentlyActiveUsers || 0 }}</b> | Guest:
                <b>{{ logActivityDetails.recentlyActiveGuestUsers || 0 }}</b>
              </div>
            </div>
            <div class="w-20">
              <h1 class="value float-right">
                {{
                  ((logActivityDetails.recentlyActiveUsers && logActivityDetails.recentlyActiveUsers) || 0) +
                    ((logActivityDetails.recentlyActiveGuestUsers && logActivityDetails.recentlyActiveGuestUsers) || 0)
                }}
              </h1>
            </div>
          </div>
        </mat-card-title>
        <div class="clearfix"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <mat-card>
      <h4>
        Buyer Leads
        <span class="property-badge ml-1" [ngClass]="'badge-alert'">
          {{ logActivityDetails?.buyerLeadTotalCount || 0 }}
        </span>
      </h4>
      <div class="d-flex flex-row w-100 buyer-lead mt-4">
        <div class="data-flex" *ngIf="this.logActivityDetails?.buyerLead?.nurturing?.length">
          <div class="data-grid">
            <p class="tag-badge tag1">{{ constant.LEAD_SCORE_TAG.nurturing }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div class="flex-grow-1" *ngFor="let buyer of this.logActivityDetails?.buyerLead?.nurturing">
              <h6>{{ buyer.displayText }}</h6>
              <h3>{{ buyer.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="this.logActivityDetails?.buyerLead?.qualified?.length">
          <div class="data-grid">
            <p class="tag-badge tag2">{{ constant.LEAD_SCORE_TAG.qualified }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div class="flex-grow-1" *ngFor="let buyer of this.logActivityDetails?.buyerLead?.qualified">
              <h6>{{ buyer.displayText }}</h6>
              <h3>{{ buyer.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="this.logActivityDetails?.buyerLead?.customer?.length">
          <div class="data-grid">
            <p class="tag-badge tag3">{{ constant.LEAD_SCORE_TAG.customer }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div class="flex-grow-1" *ngFor="let buyer of this.logActivityDetails?.buyerLead?.customer">
              <h6>{{ buyer.displayText }}</h6>
              <h3>{{ buyer.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="this.logActivityDetails?.buyerLead?.client?.length">
          <div class="data-grid">
            <p class="tag-badge tag4">{{ constant.LEAD_SCORE_TAG.client }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div class="flex-grow-1" *ngFor="let buyer of this.logActivityDetails?.buyerLead?.client">
              <h6>{{ buyer.displayText }}</h6>
              <h3>{{ buyer.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <br />
      <h4 class="mt-3">
        Seller Leads
        <span class="property-badge ml-1" [ngClass]="'badge-alert'">
          {{ logActivityDetails?.sellerLeadTotalCount || 0 }}
        </span>
      </h4>
      <div class="d-flex flex-row w-100 seller-lead mt-4 mb-2">
        <div class="data-flex" *ngIf="logActivityDetails?.sellerLead?.nurturing?.length">
          <div class="data-grid">
            <p class="tag-badge tag1">{{ constant.LEAD_SCORE_TAG.nurturing }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div *ngFor="let seller of logActivityDetails?.sellerLead?.nurturing">
              <h6>{{ seller.displayText }}</h6>
              <h3>{{ seller.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="logActivityDetails?.sellerLead?.qualified?.length">
          <div class="data-grid">
            <p class="tag-badge tag2">{{ constant.LEAD_SCORE_TAG.qualified }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div *ngFor="let seller of logActivityDetails?.sellerLead?.qualified">
              <h6>{{ seller.displayText }}</h6>
              <h3>{{ seller.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="logActivityDetails?.sellerLead?.customer?.length">
          <div class="data-grid">
            <p class="tag-badge tag3">{{ constant.LEAD_SCORE_TAG.customer }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div *ngFor="let seller of logActivityDetails?.sellerLead?.customer">
              <h6>{{ seller.displayText }}</h6>
              <h3>{{ seller.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>

        <div class="data-flex" *ngIf="this.logActivityDetails?.sellerLead?.client?.length">
          <div class="data-grid">
            <p class="tag-badge tag4">{{ constant.LEAD_SCORE_TAG.client }}</p>
          </div>
          <div class="d-flex flex-row leadscore_wrap">
            <div *ngFor="let seller of this.logActivityDetails?.sellerLead?.client">
              <h6>{{ seller.displayText }}</h6>
              <h3>{{ seller.count }}</h3>
              <p class="mb-0 mt-1"></p>
            </div>
          </div>
        </div>
      </div>
      <p
        class="mt-4 cancel-score text-secondary font-italic"
        *ngIf="
          this.logActivityDetails?.buyerLead?.canceled[0]?.count +
            this.logActivityDetails?.sellerLead?.canceled[0]?.count >
          0
        "
      >
        {{ this.logActivityDetails?.buyerLead?.canceled[0]?.displayText }} Leads :
        <b>{{
          this.logActivityDetails.buyerLead?.canceled[0]?.count +
            this.logActivityDetails?.sellerLead?.canceled[0]?.count
        }}</b>
      </p>
    </mat-card>
  </div>
</div>
<br />

<div class="row">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <mat-card-title
          ><h4>CMA Emails <span class="postfix">in the last 30 days</span></h4>
        </mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="row pr-3">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">CMA Shared</p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((cmaSentCount || 0) / cmaSentCount) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value">{{ cmaSentCount || 0 }} </span>
                </div>
              </div>
              <div class="row pr-3">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">CMA Emails Opened</p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((cmaReadCount || 0) / cmaReadCount) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value"> {{ cmaReadCount || 0 }}</span>
                </div>
              </div>
              <!-- <div class="row pr-3" style="cursor: pointer" (click)="navigateToMarketingTab('engaged')">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">
                    CMA's Viewed
                    <img
                      matTooltip="Number of distinct leads who opened an email in the last 30 days."
                      src="assets/images/info-circle.svg"
                      height="16"
                    />
                  </p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((logActivityDetails.campaignEngaged || 0) / logActivityDetails.campaignEmailSend) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value">{{ logActivityDetails.campaignEngaged || 0 }}</span>
                </div>
              </div> -->
            </div>
            <!-- <div
              class="col-lg-6 col-md-6 col-sm-12 col-12"
              style="cursor: pointer"
              (click)="navigateToMarketingTab('click-through')"
            >
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.campaignEmailClick || 0 }}
                </span>
                <span class="Property-head"
                  >Click-Through
                  <img
                    matTooltip="Number of leads that clicked through the listings included in the email"
                    src="assets/images/info-circle.svg"
                    height="16"
                  />
                </span>
              </div>
            </div> -->
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<br />

<div class="row">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <mat-card-title
          ><h4>Marketing Automation <span class="postfix">in the last month</span></h4>
        </mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="row pr-3">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">Emails Sent</p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((logActivityDetails.campaignEmailSend || 0) / logActivityDetails.campaignEmailSend) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value">{{ logActivityDetails.campaignEmailSend || 0 }} </span>
                </div>
              </div>
              <div class="row pr-3">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">Emails Opened</p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((logActivityDetails.campaignEmailOpen || 0) / logActivityDetails.campaignEmailSend) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value"> {{ logActivityDetails.campaignEmailOpen || 0 }}</span>
                </div>
              </div>
              <div class="row pr-3" style="cursor: pointer" (click)="navigateToMarketingTab('engaged')">
                <div class="col-md-4 col-sm-6 col-6">
                  <p class="Property-head">
                    Leads Engaged
                    <img
                      matTooltip="Number of distinct leads who opened an email in the last 30 days."
                      src="assets/images/info-circle.svg"
                      height="16"
                    />
                  </p>
                </div>
                <div class="col-md-8 col-sm-6 col-6">
                  <mat-progress-bar
                    class="progress-bar"
                    mode="determinate"
                    style="height: 26px"
                    [value]="((logActivityDetails.campaignEngaged || 0) / logActivityDetails.campaignEmailSend) * 100"
                  ></mat-progress-bar>
                  <span class="progress-value">{{ logActivityDetails.campaignEngaged || 0 }}</span>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-6 col-sm-12 col-12"
              style="cursor: pointer"
              (click)="navigateToMarketingTab('click-through')"
            >
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.campaignEmailClick || 0 }}
                </span>
                <span class="Property-head"
                  >Click-Through to Listings
                  <img
                    matTooltip="Number of leads that clicked through the listings included in the email"
                    src="assets/images/info-circle.svg"
                    height="16"
                  />
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<br />
<div class="row" *ngIf="authorizeService.canView('leadWebActivityManager')">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <mat-card-title
          ><h4>Web Activity <span class="postfix">in the last 7 days</span></h4>
        </mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">{{ logActivityDetails.siteVisit || 0 }} </span>
                <span class="Property-head">Total Visits</span>
              </div>
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'"
                  >{{ logActivityDetails.registeredVisit || 0 }}
                </span>
                <span class="Property-head">Registered User Visits</span>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'"
                  >{{ logActivityDetails.propertyDetails || 0 }}
                </span>
                <span class="Property-head">Listings Viewed</span>
              </div>
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.propertyWatch || 0 }}</span
                >
                <span class="Property-head">Listings Saved</span>
              </div>
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">{{ logActivityDetails.searchSave || 0 }} </span>
                <span class="Property-head">Searches Saved</span>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<br />
<div class="row mb-5" *ngIf="authorizeService.canView('leadWebActivity')">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <mat-card-title
          ><h4>Web Activity <span class="postfix">in the last 7 days </span></h4>
        </mat-card-title>
        <div class="clearfix"></div>
        <ng-container>
          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.registeredVisit || 0 }}
                </span>
                <span class="Property-head">My Lead Visits</span>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.propertyDetails || 0 }}
                </span>
                <span class="Property-head">Listings Viewed by my leads</span>
              </div>
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">
                  {{ logActivityDetails.propertyWatch || 0 }}
                </span>
                <span class="Property-head">Listings Saved by my leads</span>
              </div>
              <div class="property-badge-wrapper mb-3">
                <span class="property-badge" [ngClass]="'badge-alert'">{{ logActivityDetails.searchSave || 0 }} </span>
                <span class="Property-head">Searches Saved by my leads</span>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
